import { Component, ChangeDetectorRef, AfterContentInit, OnInit } from '@angular/core';
import { version } from '../../package.json';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterContentInit {
  version: string = version;
  image_header_presence: boolean;
  loading = false;

  constructor(private router: Router,
              private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.router.events.subscribe((e) => {
      const actual_route = this.router.url;
      const actual_path_from_url = actual_route.split('/').pop();
      if ('home' === actual_path_from_url) {
        this.image_header_presence = true;
      } else {
        this.image_header_presence = false;
      }
      if (e instanceof NavigationStart) {
        this.loading = true;
        window.scrollTo(0, 0);
        // document.body.scrollTop = 0; // For Safari
        // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      } else if (e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError) {
        this.loading = false;
      }
    });
  }

  ngAfterContentInit(): void {
    this.cdRef.detectChanges();
  }
}
